/**
 * Ссылки из справки в руководства (§11, фаза 10, задача 11).
 *
 * Руководства лежат в `docs/guides` и раздаются вместе с интерфейсом
 * по пути `/docs/`: в продакшене их кладёт в статику образ Caddy,
 * в разработке отдаёт плагин Vite (см. `vite.config.ts`). Один источник
 * правды — файл в репозитории; копии текста внутри приложения нет.
 *
 * Якорь задаётся здесь, а не строкой на месте вызова: заголовок в файле
 * могут переписать, и тогда чинить надо одно место, а не десять.
 */

const BASE = '/docs/';

export const GUIDE_ANCHORS = {
  /** Способ доступа к архиву камеры. */
  archiveProvider: 'user.md#sposob-dostupa',
  /** Пороги монитора. */
  monitorThresholds: 'user.md#porogi',
  /** Слои карты. */
  mapLayers: 'user.md#sloi',
} as const;

export type GuideAnchor = keyof typeof GUIDE_ANCHORS;

export function guideUrl(anchor: GuideAnchor): string {
  return `${BASE}${GUIDE_ANCHORS[anchor]}`;
}
